<script>
  import solicitacaoFaturamentoMultiservicoServico from '../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import formasPagamento from '~modulos/solicitacao-faturamento/formas-pagamento';
  import ListaServicos from './compartilhado/FormListaServicos.vue';
  import tiposConta from '~js/tipos-conta';
  import Barcode from '@xkeshi/vue-barcode';

  export default {
    components: { Cabecalho, ListaServicos, Barcode },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        formasPagamento: formasPagamento,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoFaturamentoMultiservicoServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          });
      },
      formaPagamento(id) {
        return this.formasPagamento.find(f => {
          return f.id === id;
        });
      },
      tipoConta(tipo) {
        return tiposConta.find(tipoConta => {
          return tipoConta.id === tipo; 
        }).nome;
      }
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.solicitacao.projeto.dataInicioVigencia;
        let dataTermino = this.solicitacao.projeto.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }

        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }

        return periodo;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.liberacaoCoordenador) || '---';
      }
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Faturamento Multiserviços - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = true;
      this.$root.botaoRetrocederRota = 'solicitacao-faturamento-multiservicos';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              
              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="'Solicitação de Faturamento Multiserviços'"></cabecalho>

                <h3 class="m-t-none m-b">Dados da solicitação</h3>

                <div class="hr-line-dashed margin-top-5"></div>
                
                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Projeto</dt>
                    <dd>{{ solicitacao.projeto.idProjeto }} - {{ solicitacao.projeto.nomeProjeto }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Tipo de projeto</dt>
                    <dd>{{ solicitacao.projeto.tipoProjeto ? solicitacao.projeto.tipoProjeto.nome : '---' }}</dd>
                  </dl>
                </div>
                
                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Período de vigência</dt>
                    <dd>{{ periodoDeVigencia }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Nr. processo</dt>
                    <dd>{{ solicitacao.projeto.nrProcesso || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.idSolicitacaoFaturamentoMc }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Data da solicitação</dt>
                    <dd>{{ solicitacao.dataSolicitacao | formatarNumeroEmDataExtenso }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Solicitante</dt>
                    <dd>{{ solicitacao.solicitante.nomePessoaFisicaJuridica }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Coordenador do projeto</dt>
                    <dd>{{ solicitacao.projeto.coordenador.nomePessoaFisicaJuridica }}</dd>
                  </dl>
                </div>
                
                <div class="row">
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Data de liberação do coordenador</dt>
                    <dd>{{ dataLiberacaoCoordenador }}</dd>
                  </dl>
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Liberado por</dt>
                    <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Nº protocolo</dt>
                    <dd>{{ solicitacao.protocolo.numeroProtocolo }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Código de barras protocolo</dt>
                    <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                  </dl>
                </div>
                
                <h3 class="m-t-none m-b">Dados para faturamento</h3>
                
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Nome</dt>
                    <dd>{{ solicitacao.nome }}</dd>
                  </dl>
                  
                  <dl class="col-xs-4">
                    <dt>{{ solicitacao.documento.length === 14 ? 'CPF' : 'CNPJ' }}</dt>
                    <dd>{{ solicitacao.documento }}</dd>
                  </dl>
                </div>

                <div class="row" v-show="solicitacao.documento.length > 14">
                  <dl class="col-xs-6">
                    <dt>Inscrição estadual</dt>
                    <dd>{{ solicitacao.inscricaoEstadual || '---' }}</dd>
                  </dl>
                  
                  <dl class="col-xs-6">
                    <dt>Inscrição municipal</dt>
                    <dd>{{ solicitacao.inscricaoMunicipal || '---' }}</dd>
                  </dl>
                </div>
                
                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Endereço</dt>
                    <dd>{{ solicitacao.enderecoFaturamento }}</dd>
                  </dl>
                  
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.numeroFaturamento }}</dd>
                  </dl>
                  
                  <dl class="col-xs-3">
                    <dt>Complemento</dt>
                    <dd>{{ solicitacao.complementoFaturamento || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Bairro</dt>
                    <dd>{{ solicitacao.bairroFaturamento }}</dd>
                  </dl>
                  
                  <dl class="col-xs-3">
                    <dt>Cidade</dt>
                    <dd>{{ solicitacao.cidadeFaturamento }}</dd>
                  </dl>
                  
                  <dl class="col-xs-3">
                    <dt>Estado</dt>
                    <dd>{{ solicitacao.ufFaturamento }}</dd>
                  </dl>
                  
                  <dl class="col-xs-3">
                    <dt>CEP</dt>
                    <dd>{{ solicitacao.cepFaturamento }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Observação</dt>
                    <dd>{{ solicitacao.obsFaturamento || '---' }}</dd>
                  </dl>
                </div>
                
                <h3 class="m-t-none m-b">Dados para cobrança</h3>
                
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Endereço</dt>
                    <dd>{{ solicitacao.enderecoCobranca }}</dd>
                  </dl>
                  
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.numeroCobranca }}</dd>
                  </dl>
                  
                  <dl class="col-xs-3">
                    <dt>Complemento</dt>
                    <dd>{{ solicitacao.complementoCobranca || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Bairro</dt>
                    <dd>{{ solicitacao.bairroCobranca }}</dd>
                  </dl>
                  
                  <dl class="col-xs-3">
                    <dt>Cidade</dt>
                    <dd>{{ solicitacao.cidadeCobranca }}</dd>
                  </dl>
                  
                  <dl class="col-xs-3">
                    <dt>Estado</dt>
                    <dd>{{ solicitacao.ufCobranca }}</dd>
                  </dl>
                  
                  <dl class="col-xs-3">
                    <dt>CEP</dt>
                    <dd>{{ solicitacao.cepCobranca }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Dados para fatura</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Data de vencimento</dt>
                    <dd>{{ solicitacao.dataPagamento | formatarNumeroEmData }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>Forma de pagamento</dt>
                    <dd>{{ formaPagamento(solicitacao.formaPagamento).nome }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Unidade</dt>
                    <dd>{{ solicitacao.unidade.nomeUnidade }}</dd>
                  </dl>
                  
                  <dl class="col-xs-6">
                    <dt>Departamento</dt>
                    <dd>{{ solicitacao.departamento.nomeDepartamento }}</dd>
                  </dl>
                </div>
                
                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Pagamento Por</dt>
                    <dd>{{ solicitacao.formaPagamento ? 'Depósito em conta' : 'Boleto bancário' }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="solicitacao.formaPagamento">
                  <dl class="col-xs-3">
                    <dt>Banco</dt>
                    <dd>{{ solicitacao.banco }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Agência</dt>
                    <dd>{{ solicitacao.agencia }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Conta</dt>
                    <dd>{{ solicitacao.contaCorrente }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Tipo de conta</dt>
                    <dd>{{ tipoConta(solicitacao.tipoConta) }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Enviar email para</dt>
                    <dd class="white-space-pre">{{ solicitacao.observacao }}</dd>
                  </dl>
                </div>
                
                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Código do serviço</dt>
                    <dd>{{ solicitacao.codItemServico.descricao }}</dd>
                  </dl>
                </div>
                
                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Observação (cotação, condições de pagamento e pedido de compra)</dt>
                    <dd class="white-space-pre">{{ solicitacao.complemento || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Serviços</h3>

                <div class="hr-line-dashed margin-top-5"></div>
                
                <lista-servicos 
                    :itensSolicitacao="solicitacao.itens" 
                    :relatorio="true">
                </lista-servicos>
                
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-multiservicos/componentes/SolicitacaoFaturamentoMultiservicoRelatorio.vue